module.exports = {
	"ERROR_401": "Error 401: not authorized",
	"ERROR_403": "Error 403: forbidden",
	"ERROR_404": "Error 404: not found",
	"ERROR": "Error. Unable to perform requested operation",
	"NOT_AUTHORIZED": "You have to sign in to visit this page",
	"FORBIDDEN": "You have no permission to see this page",
	"NOT_FOUND": "Unable to find requested page",
	"CLOSE": "Close",
	"SEND": "Send",
	"ADD": "Add",
	"EDIT": "Edit",
	"DELETE": "Delete",
	"LIST": "List",
	"YES": "Yes",
	"NO": "No",
	"SUBMIT": "Submit",
	"SAVE": "Save",
	"CANCEL": "Cancel",
	"SUCCESS": "Operation executed successfully",
	"REQUIRED": "Required",
	"EXPECTED_NUMBER": "A number is expected",
	"MAX_LENGTH": "Max length will be {maxLength}",
	"MIN_LENGTH": "Min length will be {minLength}",
	"MAX_AND_MIN_LENGTH": "Max length will be {maxLength} and Min length will be {minLength}",
	"INVALID_FORMAT": "Invalid format",
	"INVALID_VALUE": "Invalid value",
	"ATTENTION": "Attention",
	"CONFIRM_EXIT": "Are you sure want to leave?",
	"HELP": "Help",
	"FINISH": "Finish",
	"NEXT": "Next",
	"BACK": "Back",
	"EXAMPLE_NUMBER": "Eg: 1",
	"ALL": "All",
	"ALL_PLURAL": "All",
	"SET": "Set",
	"SET_PAGE": "Set page",
	"PREVIEW": "Preview",
	"SETTINGS": "Settings",
	"GENERAL": "General",
	"NAME": "Nome",
	"THEME": "Theme",
	"COLOR": "Color",
	"RED": "Red",
	"YELLOW": "Yellow",
	"BLUE": "Blue",
	"GREEN": "Green",
	"WHITE": "White",
	"LANGUAGE": "Language",
	"LANGUAGES": "Languages",
	"EN": "English",
	"IT": "Italian",
	"SHORT_DESCRIPTION": "Description",
	"TEMPLATE_ID": "Template",
	"ITERATION_FRAME_ID": "Tempo permanenza pagina",
	"ITERATION_ID": "Iteration",
	"DEPARTMENT_ID": "Department",
	"IPV4_LAN1": "IPv4 first LAN",
	"PORT_LAN1": "Port first LAN",
	"MACADDRESS_LAN1": "Mac address first LAN",
	"IPV4_LAN2": "IPv4 second LAN",
	"PORT_LAN2": "Port second LAN",
	"MACADDRESS_LAN2": "Mac address second LAN",
	"LOCATION": "Location",
	"SERIAL_NUMBER": "Serial number",
	"FIRMWARE_VERSION": "Firmware version",
	"TECHNICAL_NAME": "Technical name",
	"NOTES": "Notes",
	"IS_ACTIVE": "Active",
	"IPV4_LAN1_NOT_REACHABLE": "(!!!) IPv4 first LAN",
	"IPV4_LAN2_NOT_REACHABLE": "(!!!) IPv4 second LAN",
	"DEPARTMENT": "Department",
	"DEPARTMENTS": "Departments",
	"NEW_DEPARTMENT": "New department",
	"EXAMPLE_DEPARTMENT": "Eg: Caronno",
	"EXAMPLE_NAME": "Eg: Eurotranciatura's display",
	"EXAMPLE_LOCATION": "Eg: Bollate",
	"EXAMPLE_TECHNICAL_NAME": "Eg: Mario Rossi",
	"EXAMPLE_IPADDRESS": "Eg: 192.168.20.30",
	"EXAMPLE_PORT": "Eg: 20000",
	"EXAMPLE_MACADDRESS": "Eg: 3D:F2:C9:A6:B3:4F",
	"EXAMPLE_SERIAL_NUMBER": "Eg: 11111111",
	"EXAMPLE_FIRMWARE_VERSION": "Eg: 1.0.1",
	"EXAMPLE_TEMPLATE_NAME": "Eg: 2 lines display",
	"INVALID_IPADDRESS": "Invalid IP Address",
	"INVALID_MACADDRESS": "Invalid MAC Address",
	"INVALID_VERSION": "Invalid version",
	"DISPLAY": "Display",
	"DISPLAYS": "Displays",
	"DISPLAY_MANAGER": "Display manager",
	"NEW_DISPLAY": "Add display",
	"DELETE_DISPLAY": "Delete display",
	"EDIT_DISPLAY": "Edit display",
	"GENERAL_DATA": "General data",
	"TECHNICAL_DATA": "Technical data",
	"FRAME_NUMBER": "Number of pages",
	"FRAME_ORDER": "Move to position...",
	"TIMER": "Timer",
	"TIMERS": "Timers",
	"NEW_TIMER": "New timer",
	"SECONDS": "Seconds",
	"SEC": "Sec.",
	"EXAMPLE_TIMER_NAME": "Fast timer",
	"FREQUENCY": "Frequency (sec.)",
	"EXAMPLE_FREQUENCY": "Eg: 30",
	"TIMER_FREQUENCY": "Frequency {seconds} sec.",
	"TEMPLATE": "Template",
	"TEMPLATES": "Templates",
	"NEW_TEMPLATE": "New template",
	"TEMPLATE_MAP": "Fields",
	"FIELD_NUM": "Field {fieldNum}",
	"ROW_NUM": "Row {rowNum}",
	"FRAME_NUM": "Page {frameNum}",
	"MAP": "Field",
	"MAPS": "Fields",
	"NEW_MAP": "New field",
	"FIELD": "Field",
	"EXAMPLE_FIELD": "Eg: 1",
	"ROW": "Row",
	"EXAMPLE_ROW": "Eg: 2",
	"WIDTH": "Width",
	"EXAMPLE_Width": "Eg: 10",
	"DYNAMIC_FIELD": "Dynamic Field",
	"FIELD_DESCRIPTION": "From position {start} for {length} characters",
	"DELETE_FIELD_ERROR": "Unable to delete field. Ensure that no display are using it.",
	"ADAPTER_NUM": "Network adapter",
	"MULTI_CHARACTER": "Special font",
	"SLIDING": "Sliding",
	"INTERMITTENCE": "Intermittence",
	"INDICATOR": "Indicator",
	"POSITIVE": "Positive",
	"NEGATIVE": "Negative",
	"CREATE_TIMER": "Creazione timer",
	"CREATE_TEMPLATE": "Creazione template",
	"CREATE_DISPLAY": "Creazione display",
	"HELP_INTRODUCTION": "Per procedere con la creazione di un display è necessario seguire i brevi passi riportati di seguito:",
	"CREATE_TIMER_DESCRIPTION": "I timer ti consentono di stabilire con che periodicità è necessario aggiornare i display. Imposta il timer del display interessato pari al tempo di aggiornamento del campo maggiormente soggetto a cambiamenti.\nCrea un timer cliccando sull'apposita voce di menu.",
	"CREATE_TEMPLATE_DESCRIPTION": "I template ti permettono di costruire un display specificando le sue caratteristiche. I template rispecchiano essenzialmente la struttura dei vari modelli di display: è necessario descrivere ogni singolo campo nei particolari per permettere la creazione del suo modello virtuale.\nCrea un template cliccando sull'apposita voce di menu e aggiungi i campi da cui è costituito.",
	"CREATE_DISPLAY_DESCRIPTION": "La sezione display ti permette, fornendo gli opportuni dati, timer e template, di creare effettivamente i display in uso nei vari reparti. Imposta il numero di pagine per ottenere un'alternanza di testi da visualizzare dopo l'intervallo dei timer. Una volta creato un display è possibile selezionarlo per modificare i dati che dovrà mostrare.\nCrea un display cliccando sull'apposita voce di menu.",
	"CAN_CREATE_DISPLAY": "Hai terminato il tutorial, puoi iniziare ora ad impostare i display.",
	"CONFIGURATION": "Configuration",
	"LEGEND": "Legend",
	"TUTORIAL": "\nQuesta guida si applica solo alla prima riga del display.\nLa modalità predefinita è TESTO FISSO.\nPer scrivere una singola riga senza effetti speciali è sufficiente scrivere il testo da visualizzare.\nPer scrivere righe multiple, impostare al termine di ogni riga tranne l'ultima il carattere § (sopra la ù a fianco all'invio).\nPer attribuire ad ogni riga effetti speciali impostare prima della riga la seguenza di caratteri che impostano la modalità scelta.\nLe modalità sono:\n- font (carattere) -> i valori consentiti sono: normal (predefinito) e big. Esempio: #font=big;\n- type (modalità di visualizzazione) -> valori consentiti sono: static (predefinito) che permette la visualizzazione di testo statico, scroll che visualizza il testo in modalità scorrimento. E' possibile anche specificare la velocità di scorrimento esprimendo un valore tra 1 e 255. E' inoltre possibile indicare il tempo in secondi di permanenza della riga sul monitor nella modalità static. Esempio: #type=scroll,10; oppure #type=static,2\n- effect (effetto speciale) -> valori consentiti sono: blink (che permette di far lampeggiare il testo) stop (permette di tenere bloccato il testo della riga evitando la ripetizione). Esempio #effect:stop;\n\nNon specificando i vari attributi per le righe successive saranno mantenute le ultime impostazioni inserite.\n\nESEMPIO COMPLETO:\nVogliamo scrivere 4 righe, la prima a scorrimento a velocità 50/255 a carattere grande, la seconda e la terza carattere normale con blink che rimanga impressa per 10 secondi e la quarta con carattere grande con stop, potremmo scrivere il seguente comando:\n#font=big;#type=scroll,50;TESTO CHE SCORRE SULLA PRIMA RIGA§#font=normal;#type=static,10;#effect:blink;TESTO DA METTERE SULLA SECONDA RIGA§TESTO DA METTERE SULLA TERZA RIGA§#font=big;#effect:stop;QUARTA RIGA CON STOP\n\nSe il campo è ottenuto da un plugin, sarà compito del plugin stesso creare il testo con le modalità sopra citate.",
	"SET_CURRENT_PAGE": "Set current page"
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/i18n/en.json
 ** module id = 819
 ** module chunks = 0
 **/